'use strict';

angular.module('pmtPlacesApp.directives').directive('pmtLocationEditLocation', [
	'$stateParams',
	'LocationEditService',
	'pmtEnabledNetworksService',
	'pmtUtilService',
	function ($stateParams, LocationEditService, pmtEnabledNetworksService, pmtUtilService) {
		return {
			restrict: 'A',
			replace: true,
			scope: {
				place: '=pmtLocationEditLocation',
				onUpdate: '<',
				onClose: '&',
				noPartialUpdate: '<',
				openDialog: '='
			},
			link: function (scope /*, element, attrs*/) {
				scope.updatePlace = {};

				const getMarkers = function (place) {
					const isApproved = network =>
						pmtUtilService.getByPath([network, 'idSetType'], place) === 'approved';
					const markers = [];
					if (pmtEnabledNetworksService.isEnabled('facebook') && isApproved('fb')) {
						markers.push({ iconType: 'facebook', location: place.fb.data.location });
					}
					if (
						pmtEnabledNetworksService.isEnabled('google') &&
						isApproved('google') &&
						place.google.data.location
					) {
						markers.push({ iconType: 'google', location: place.google.data.location });
					}
					if (pmtEnabledNetworksService.isEnabled('bing') && isApproved('bing')) {
						markers.push({ iconType: 'bing', location: place.bing.data.location });
					}
					return markers;
				};

				let site = $stateParams.site,
					setModel = function () {
						scope.updatePlace.location = {};
						scope.updatePlace.location.lat = parseFloat(scope.place.location.lat);
						scope.updatePlace.location.lon = parseFloat(scope.place.location.lon);
						scope.mapConfiguration = {
							location: scope.updatePlace.location,
							iconType: 'pinmeto',
							draggable: true
						};
						scope.networkMarkers = getMarkers(scope.place);
					},
					placeUpdated = function (data) {
						angular.extend(scope.place, data.place);
						scope.onUpdate(data.workId, data.place);
						scope.openDialog = false;
					},
					errorUpdatePlace = function () {
						scope.showErrorSaving = true;
						scope.showSavingProgress = false;
					},
					confirmGeoLocation = function (data) {
						return Promise.resolve(data);
					};
				scope.changedPositionOnMap = function (newCoords) {
					scope.updatePlace.location = {
						lat: newCoords.lat,
						lon: newCoords.lon
					};
					scope.$apply();
				};

				scope.updateLocation = function () {
					scope.mapConfiguration = {
						location: scope.updatePlace.location,
						iconType: 'pinmeto',
						draggable: true
					};
				};

				scope.decimalCheck = num => {
					switch (num?.toString().split('.')[0].length) {
						case 1:
							return '9';
						case 2:
							return '10';
						case 3:
							return '11';
						default:
							return '8';
					}
				};

				scope.updateAll = function () {
					scope.showSavingProgress = true;
					LocationEditService.updateAllPartial(site, scope.place._id, scope.updatePlace).then(
						placeUpdated,
						errorUpdatePlace
					);
				};

				scope.save = function () {
					if (
						scope.updatePlace.location !== scope.place.location ||
						LocationEditService.hasDiff(scope.place, scope.updatePlace.location, 'location')
					) {
						if (scope.noPartialUpdate) {
							scope.showSavingProgress = true;
							scope.place.location = scope.updatePlace.location;
							confirmGeoLocation({ place: scope.place }).then(placeUpdated, errorUpdatePlace);
						} else {
							scope.showSavingProgress = true;
							LocationEditService.savePartial(site, scope.place._id, scope.updatePlace)
								.then(confirmGeoLocation, errorUpdatePlace)
								.then(placeUpdated, errorUpdatePlace);
						}
					}

					scope.openDialog = false;
					scope.onClose();
				};

				scope.cancel = function () {
					scope.updatePlace = {};
					scope.openDialog = false;
					scope.onClose();
				};

				scope.$watch('openDialog', function (newVal, oldVal) {
					if (newVal === oldVal) {
						return;
					}
					if (newVal) {
						scope.showSavingProgress = false;
						scope.showErrorSaving = false;
						setModel();
					} else {
						scope.mapConfiguration = null;
					}
				});
			},
			templateUrl: 'shared/location/edit/location/pmtLocationEditLocationView.html'
		};
	}
]);
